const INSTAGRAM_CREDENTIALS = {
  /* @deprecated */
  USER_ID: '1926181334',
  ACCESS_TOKEN:
    'IGQVJVdjVPcFlmYVJCVjZAwU2FkLUdYdElTb0xTZADI3UUdMYjBsZA2VGY3c2eXZAPdlNINUFxdGpaVWZArWXFhSndvc0lSOFFRRUs3M045WFpFa0ZAIZADJuU1A2TG93VGlheGtnU0pqODIwTVJKTlFEU3ZAZAZAAZDZD',
};

export { INSTAGRAM_CREDENTIALS };
